import React from "react";
import { Grid } from "@mui/material";

import StatCard from "./StatCard";

// Pass the output of computeDashboardStats() from statsTransforms.js
export default function StatsSection({ stats }) {
    const cards = [
        {
            title: "Active Bookings",
            value: stats.activeBookings.value,
            subtitle: stats.activeBookings.subtitle,
        },
        {
            title: "Pending Approvals",
            value: stats.pendingApprovals.value,
            subtitle: stats.pendingApprovals.subtitle,
        },
        {
            title: "Items to return",
            value: stats.itemsToReturn.value,
            subtitle: stats.itemsToReturn.subtitle,
        },
        {
            title: "Active Projects",
            value: stats.activeProjects.value,
            subtitle: stats.activeProjects.subtitle,
        },
    ];

    return (
        <Grid container spacing={3} sx={{ mb: 3 }}>
            {cards.map((card) => (
                <Grid item xs={12} sm={6} lg={3} key={card.title}>
                    <StatCard {...card} />
                </Grid>
            ))}
        </Grid>
    );
}